import { render, staticRenderFns } from "./SwitchAliare.vue?vue&type=template&id=29caa509&scoped=true&"
import script from "./SwitchAliare.vue?vue&type=script&lang=ts&"
export * from "./SwitchAliare.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchAliare.vue?vue&type=style&index=0&id=29caa509&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29caa509",
  null
  
)

export default component.exports